/**
 * Hide OOS Variant Swatches
 * 
 * Hides color swatches on PDP where ALL size variants for that
 * color are unavailable (inventory 0 + deny policy).
 * 
 * Reads the product JSON already embedded in the page by the theme.
 * No API calls needed. Works with Symmetry theme swatch rendering.
 *
 * This prevents unreleased colors (like Blue Opal) from showing
 * up as swatches when images are added but inventory is still 0.
 */
(function() {
  'use strict';

  function hideOOSSwatches() {
    /* Find the product JSON script block in the page */
    var scripts = document.querySelectorAll('script[type="application/json"]');
    var productData = null;

    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (data && data.variants && data.variants.length > 1 && data.variants[0].option1) {
          productData = data;
          break;
        }
      } catch (e) {}
    }

    if (!productData || !productData.variants) return;

    /* Build a map: color → { total: N, unavailable: N } */
    var colorMap = {};
    productData.variants.forEach(function(v) {
      var color = v.option1;
      if (!color) return;
      if (!colorMap[color]) colorMap[color] = { total: 0, unavail: 0 };
      colorMap[color].total++;
      if (!v.available) colorMap[color].unavail++;
    });

    /* Find colors where ALL variants are unavailable */
    var hiddenColors = [];
    Object.keys(colorMap).forEach(function(color) {
      if (colorMap[color].total === colorMap[color].unavail) {
        hiddenColors.push(color.toLowerCase().replace(/"/g, ''));
      }
    });

    if (!hiddenColors.length) return;

    /* Hide swatch labels matching these colors */
    /* Symmetry renders swatches as: <label data-swatch="color name"> */
    document.querySelectorAll('[data-swatch]').forEach(function(label) {
      var swatchVal = (label.getAttribute('data-swatch') || '').toLowerCase();
      if (hiddenColors.indexOf(swatchVal) !== -1) {
        /* Hide the label and its associated radio input */
        label.style.display = 'none';
        var forId = label.getAttribute('for');
        if (forId) {
          var input = document.getElementById(forId);
          if (input) input.style.display = 'none';
        }
      }
    });

    /* Also handle dropdown-style selects if theme uses them */
    document.querySelectorAll('.option-selector select option, .custom-select__option').forEach(function(opt) {
      var val = (opt.textContent || opt.value || '').trim().toLowerCase().replace(/"/g, '');
      if (hiddenColors.indexOf(val) !== -1) {
        opt.style.display = 'none';
        opt.disabled = true;
      }
    });
  }

  /* Run after DOM is ready and give theme JS time to render swatches */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(hideOOSSwatches, 500);
      setTimeout(hideOOSSwatches, 2000); /* second pass for late-rendering */
    });
  } else {
    setTimeout(hideOOSSwatches, 500);
    setTimeout(hideOOSSwatches, 2000);
  }

  /* Also watch for dynamic content changes */
  var observer = new MutationObserver(function(mutations) {
    var hasNewSwatches = mutations.some(function(m) {
      return m.addedNodes.length > 0;
    });
    if (hasNewSwatches) hideOOSSwatches();
  });
  var target = document.querySelector('.option-selectors') || document.body;
  observer.observe(target, { childList: true, subtree: true });
})();
